module.exports = {
    region: 'id',
    registerUrl: 'https://ttttop.online', //注册地址
    inviteCode: 'YP393', //邀请码
    title: '90t - Investasi Olahraga - Peluang Baru menghasilkan Uang', //标题
    description: '90t adalah platform investasi olahraga online terbesar di Asia, bereputasi, pendapatan stabil, sederhana dan mudah dimengerti. Pendaftaran gratis, platform stabil, keamanan tinggi, dipercaya dan dihargai oleh banyak pemain.', //描述
    tgUrl: '',
	googleId: '',
}